// eslint-disable-next-line max-classes-per-file
const ext = require('deep-extend');
const q = require('queried');
const ajax = require('component-ajax');

const {
  View,
  Controller,
  createUrl,
} = require('./core');

class LoadMoreController extends Controller {
  constructor(...args) {
    super(...args);

    const isElementInitiallyHidden = this.view.element.hasAttribute('hidden');
    const initialState = {
      page: {
        hasMoreItemsToLoad: !isElementInitiallyHidden,
      },
    };

    const prevButton = document.querySelector('.feed-pagination__prev');
    const nextButton = document.querySelector('.feed-pagination__next');

    prevButton.addEventListener('click', () => this.prevClick());
    nextButton.addEventListener('click', () => this.nextClick());

    this.model.update((state) => ext(state, initialState));
    this.pageClick = this.pageClick.bind(this);
    this.prevClick = this.prevClick.bind(this);
    this.nextClick = this.nextClick.bind(this);
    this.initRequest = this.initRequest.bind(this);

    this.initRequest();

    // new request when url changes
    this.url = document.location.href;
    const body = document.querySelector('body');
    const observer = new MutationObserver(() => {
      if (this.url !== document.location.href) {
        this.url = document.location.href;
        this.initRequest();
      }
    });
    observer.observe(body, { childList: true, subtree: true });
  }

  getQueryUrl() {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('page')) {
      this.pageParam = Number(searchParams.get('page'));
    }
    return `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
  }

  initRequest() {
    const paginationWrapper = document.querySelector('.feed-pagination__buttons');
    paginationWrapper.innerHTML = '';

    ajax({
      url: this.getQueryUrl(),
      data: {},
      success: (data) => {
        const prevButton = document.querySelector('.feed-pagination__prev');
        const nextButton = document.querySelector('.feed-pagination__next');

        if (data.num_pages) {
          for (let i = 0; i < data.num_pages; i++) {
            paginationWrapper.innerHTML += `<div class="feed-pagination__button feed-pagination__button-${i + 1}">${i + 1}</div>`;
          }

          const buttons = document.querySelectorAll('.feed-pagination__button');

          buttons[0].insertAdjacentHTML('afterend', '<span class="feed-pagination__dots-1">...</span>');
          buttons[data.num_pages - 1].insertAdjacentHTML('beforebegin', '<span class="feed-pagination__dots-2">...</span>');

          buttons.forEach((button) => {
            button.addEventListener('click', (e) => this.pageClick(e));
          });

          this.pageCount = data.num_pages;
          this.pageNumber = 1;

          if (this.pageParam && this.pageParam <= data.num_pages) {
            this.pageNumber = this.pageParam;
            this.pageParam = null;
          }

          buttons[this.pageNumber - 1]
            .classList.add('feed-pagination__button-active');

          prevButton.style.visibility = 'visible';
          nextButton.style.visibility = 'visible';
          this.checkButtonsView();
        } else {
          prevButton.style.visibility = 'hidden';
          nextButton.style.visibility = 'hidden';
        }
      },
    });
  }

  checkActiveButton() {
    const activeButton = document.querySelector('.feed-pagination__button-active');

    if (activeButton) {
      activeButton.classList.remove('feed-pagination__button-active');
    }

    document.querySelector(`.feed-pagination__button-${this.pageNumber}`)
      .classList.add('feed-pagination__button-active');
  }

  pageClick(e) {
    const pageNumber = parseInt(e.target.classList[1].match(/\d+/), 10);
    this.pageNumber = pageNumber;

    this.checkActiveButton();

    this.model.updateWithSync((state) => ext(state, {
      feed: '',
      page: {
        index: pageNumber,
        loadMoreInProgress: true,
      },
    }), null, this.scrollUp);
    this.checkButtonsView();
  }

  prevClick() {
    if (this.pageNumber === 1) return;
    this.pageNumber -= 1;

    this.checkActiveButton();

    this.model.updateWithSync((state) => ext(state, {
      feed: '',
      page: {
        index: this.pageNumber,
        loadMoreInProgress: true,
      },
    }), null, this.scrollUp);
    this.checkButtonsView();
  }

  nextClick() {
    if (this.pageNumber === this.pageCount) return;
    this.pageNumber += 1;

    this.checkActiveButton();

    this.model.updateWithSync((state) => ext(state, {
      feed: '',
      page: {
        index: this.pageNumber,
        loadMoreInProgress: true,
      },
    }), null, this.scrollUp);
    this.checkButtonsView();
  }

  loadMore() {
    this.model.updateWithSync((state) => {
      const index = state.page.index || 1;
      this.pageNumber = index + 1;
      if (document.querySelector('.feed-pagination__button-active')) {
        document.querySelector('.feed-pagination__button-active')
          .classList.remove('feed-pagination__button-active');
      }

      document.querySelector(`.feed-pagination__button-${index + 1}`)
        .classList.add('feed-pagination__button-active');

      return ext(state, {
        feed: '',
        page: {
          index: index + 1,
          loadMoreInProgress: true,
        },
      });
    }, null, this.scrollUp);
  }

  checkButtonsView() {
    if (this.pageCount < 10) return;
    const buttons = document.querySelectorAll('.feed-pagination__button');
    const firstDots = document.querySelector('.feed-pagination__dots-1');
    const secondDots = document.querySelector('.feed-pagination__dots-2');

    buttons.forEach((button) => {
      button.style.display = 'none';
    });
    firstDots.style.display = 'flex';
    secondDots.style.display = 'flex';

    buttons[0].style.display = 'flex';
    buttons[buttons.length - 1].style.display = 'flex';
    buttons[this.pageNumber - 1].style.display = 'flex';

    if (this.pageNumber < 7) {
      for (let i = 0; i < 7; i++) {
        buttons[i].style.display = 'flex';
      }
      firstDots.style.display = 'none';
      return;
    }

    if (this.pageNumber > (this.pageCount - 6)) {
      for (let i = this.pageCount - 1; i > this.pageCount - 8; i--) {
        buttons[i].style.display = 'flex';
      }
      secondDots.style.display = 'none';
      return;
    }

    buttons[this.pageNumber - 3].style.display = 'flex';
    buttons[this.pageNumber - 2].style.display = 'flex';
    buttons[this.pageNumber].style.display = 'flex';
    buttons[this.pageNumber + 1].style.display = 'flex';
  }

  scrollUp() {
    const scrollPoint = document.querySelector('.feed-scroll-point');
    if (scrollPoint) {
      scrollPoint.scrollIntoView();
    } else {
      document.querySelector('.feed').scrollIntoView();
    }
    window.scrollTo(0, window.scrollY - 100);
  }

  /**
   * Reset pagination index if url was changed.
   * Determine to show or hide "Load more" button.
   *
   * @param data
   * @param state
   * @param prevState
   * @returns {*}
   */
  sync(data, state, prevState) {
    const prevUrl = createUrl(prevState);
    const url = createUrl(state);

    let index = state.page.index || 1;
    if (prevUrl != url) {
      index = 1;
    }

    return ext(state, {
      page: {
        index,
        loadMoreInProgress: false,
        hasMoreItemsToLoad: data.has_more,
      },
    });
  }
}

class LoadMore extends View {
  constructor(...args) {
    super(...args);

    const feed = q('.feed') || q('.infiniteFeed-items');

    this.feed = feed;

    this.events.bind('click', () => {
      const oldMarkup = [feed.innerHTML];
      this.emit('loadMore', oldMarkup);
    });
  }

  render(state) {
    if (state.page.loadMoreInProgress) {
      this.element.classList.add('preloading');
    } else {
      this.element.classList.remove('preloading');
    }

    if (state.page.hasMoreItemsToLoad) {
      this.element.classList.remove('hide-text');
    } else {
      this.element.classList.add('hide-text');
    }
  }
}

module.exports = {
  LoadMoreController,
  LoadMore,
};
